<div class="border border-grey-300 rounded-lg p-4 bg-standardwhite w-full">
  <h3 class="mb-4">Add Action</h3>

  <div class="mb-3">
    <label class="font-semibold block mb-1">Action Description</label>
    <textarea
      pTextarea
      [(ngModel)]="newAction.ActionNote"
      name="actionDescription"
      [ngModelOptions]="{standalone:true}"
      rows="3"
      [ngClass]="{'p-invalid': showDescriptionError}"
      (ngModelChange)="onDescriptionChange()"
      class="w-full prime-input">
    </textarea>
    @if (showDescriptionError) {
      <small class="p-error block mt-1 text-danger-base">Description is required.</small>
    }
  </div>

  <div class="mb-3">
    <label class="font-semibold block mb-1">Action Type</label>
    <p-select
      [options]="actionVariations"
      optionLabel="label"
      optionValue="value"
      [(ngModel)]="selectedVariation"
      name="actionVariation"
      [ngModelOptions]="{standalone:true}"
      class="w-full prime-input"
      (onChange)="onVariationChange($event.value)">
      <ng-template let-variation pTemplate="item">
        <div class="flex flex-col">
          <span class="font-semibold">{{variation.label}}</span>
          <small class="text-grey-700">{{variation.description}}</small>
        </div>
      </ng-template>
      <ng-template let-variation pTemplate="selectedItem">
        <span class="font-semibold">{{variation.label}}</span>
      </ng-template>
    </p-select>
  </div>

  @if (selectedVariation === 2) {
    <div class="mb-3">
      <label class="font-semibold block mb-1">Required {{ 'audit' | customerTerm }}</label>
      <p-select
        [options]="auditOptions"
        optionLabel="AuditName"
        optionValue="AuditID"
        [(ngModel)]="selectedAuditId"
        name="requiredAudit"
        [ngModelOptions]="{standalone:true}"
        [placeholder]="'Select the required audit' | customerText"
        class="w-full prime-input"
        [disabled]="auditsLoading || (auditOptions || []).length === 0"
        [ngClass]="{'p-invalid': showAuditError}"
        (onChange)="onAuditChange($event.value)">
      </p-select>
      @if (auditsLoading) {
        <small class="block mt-1 text-grey-700">{{ 'Loading audits...' | customerText }}</small>
      }
      @if (!auditsLoading && (auditOptions || []).length === 0) {
        <small class="block mt-1 text-grey-700">{{ 'No audits are available for this event.' | customerText }}</small>
      }
      @if (showAuditError) {
        <small class="p-error block mt-1 text-danger-base">{{ 'Audit selection is required for this action type.' | customerText }}</small>
      }
    </div>
  }

  <div class="mb-3">
    <label class="font-semibold block mb-1">Assigned To</label>
    <p-select
      [options]="users"
      [(ngModel)]="currentUser"
      name="actionAssignee"
      [ngModelOptions]="{standalone:true}"
      optionLabel="DisplayName"
      [ngClass]="{'p-invalid': showAssigneeError}"
      class="w-full prime-input"
      [filter]="false"
      placeholder="Select a user"
      optionDisabled="Disabled"
      (onChange)="onAssigneeChange($event.value)">
      <ng-template let-user pTemplate="item">
        <span [ngClass]="{'font-bold': user?.UserTypeID === 2}">{{user?.DisplayName}}</span>
      </ng-template>
      <ng-template let-user pTemplate="selectedItem">
        <span [ngClass]="{'font-bold': user?.UserTypeID === 2}">{{user?.DisplayName}}</span>
      </ng-template>
    </p-select>
    @if (showAssigneeError) {
      <small class="p-error block mt-1 text-danger-base">Assignee is required.</small>
    }
  </div>

  <div class="mb-3">
    <label class="font-semibold block mb-1">Action Due Date</label>
    <p-datepicker
      [(ngModel)]="newAction.ActionDeadline"
      name="actionDeadline"
      [ngModelOptions]="{standalone:true}"
      (ngModelChange)="onDateChange($event)"
      inputId="eventActionDueDate"
      dateFormat="dd M yy"
      [minDate]="minDate"
      class="date-input">
    </p-datepicker>
  </div>

  <div class="flex justify-end gap-2">
    <button pButton class="btn-primary" type="button" (click)="submit()" [disabled]="saving">Add Action</button>
  </div>
</div>
